<template>
    <div class="filter-body" >
        <div class="form-group">
            <label for=""> Inbound Date</label>
            <datepicker input-class="form-control" placeholder="Select Date" v-model="inbound" format="yyyy-MM-dd" clear-button="1"/>
            <input name="inbound_at" type="hidden" v-model="inbound_at">
        </div>
        <div class="form-group">
            <label for=""> Outbound Date</label>
            <datepicker input-class="form-control" placeholder="Select Date" v-model="outbound" format="yyyy-MM-dd" clear-button="1"/>
            <input name="outbound_at" type="hidden" v-model="outbound_at">
        </div>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
export default {
  components: { Datepicker },
  data () {
    return {
      inbound: '',
      outbound: '',
      inbound_at: '',
      outbound_at: ''
    }
  },
  watch: {
    inbound () {
      if (this.inbound == null) {
        this.inbound_at = null
      }
      var timestamp = Date.parse(this.inbound)

      if (isNaN(timestamp) == false) {
        var d = new Date(timestamp)
        this.inbound_at = this.moment(d).format('YYYY-MM-DD')
      }
    },
    outbound () {
      if (this.outbound == null) {
        this.outbound_at = null
      }
      var timestamp = Date.parse(this.outbound)

      if (isNaN(timestamp) == false) {
        var d = new Date(timestamp)
        this.outbound_at = this.moment(d).format('YYYY-MM-DD')
      }
    }
  }
}
</script>
